// extracted by mini-css-extract-plugin
module.exports = {"LikeCommentButton":"LikeCommentButton_LikeCommentButton__v3JWU","LikeButton":"LikeCommentButton_LikeButton__2dDeI"};